import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';

interface CpCommerceUpdateTxnTypeDto {
  ecomsync_item_hdr_guid: string;
  txn_type: string;
}

@Injectable({
  providedIn: 'root'
})
export class CpCommerceUpdateSingleProductService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX +
    Core2Config.CPCOMMERCE_PREFIX + 'update-products/single-product';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX +
      Core2Config.CPCOMMERCE_PREFIX + 'update-products/single-product';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX +
      Core2Config.CPCOMMERCE_PREFIX + 'update-products/single-product';
    this.httpClient = http;
  }

  public updateSingleProduct(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl ;
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public updateSingleProductTxnType(dtoObject: CpCommerceUpdateTxnTypeDto, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/update-txn-type';
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
